export default {"src":"/_next/static/media/ProfilingIconCategory.5bb48420.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};